import { Component } from '@angular/core';
import { MatDialogRef } from '@angular/material';

// Definimos la interfaz ISaveScenario
export interface ISaveScenario {
  name: string;         // El nombre del escenario
  create: boolean;      // Indicador de si es nuevo o no
  editable: boolean;    // Indicador de si el escenario es editable
  _key?: string;        // Clave opcional (si existe)
}

@Component({
  selector: 'modal-save-scenario',
  templateUrl: './save-scenario.component.html'
})
export class SaveScenarioModal {
  public items: Array<any> = [];  // Aquí almacenamos los elementos de localStorage que se pueden guardar
  public editableItems: Array<any> = [];  // Filtramos los elementos que se pueden editar

  constructor(public dialog: MatDialogRef<SaveScenarioModal>) {}

  // Método para guardar el item en localStorage
  public saveItem(item: ISaveScenario): void {
    if (item) {
      const key = item._key; // Usamos la clave del item
      localStorage.setItem(key!, JSON.stringify(item));  // Guardamos el item en localStorage
      this.dialog.close(item);  // Cerramos el modal y devolvemos el item guardado
    }
  }
}
